/**
 * DvrRevisions constants (extracted Iter32 P2 — refactor pass).
 *
 * Pure data tables, zero side effects. Imported by `DvrRevisions.jsx` and any
 * future child component (sign panel, diff modal). Avoids drift across files.
 */

export const SIGNATURE_ROLE_LABELS = {
  datore_lavoro: "Datore di lavoro",
  rspp: "RSPP",
  aspp: "ASPP",
  medico_competente: "Medico competente",
  rls: "RLS — Rappresentante lavoratori",
  rlst: "RLST — Rappresentante territoriale",
};

export const DATA_CERTA_LABELS = {
  firma_digitale: "Firma digitale qualificata",
  marca_temporale: "Marca temporale",
  pec: "PEC (Posta Elettronica Certificata)",
  protocollo_interno: "Protocollo interno",
  altro: "Altro",
};

export const STATUS_LABELS = {
  draft: "Bozza",
  in_review: "In revisione",
  approved: "Approvata",
  signed: "Firmata",
  archived: "Archiviata",
};

export const STATUS_CLASSES = {
  draft: "bg-slate-100 text-slate-700",
  in_review: "bg-yellow-50 text-yellow-800",
  approved: "bg-blue-50 text-blue-900",
  signed: "bg-emerald-50 text-emerald-700",
  archived: "bg-slate-200 text-slate-600",
};

export const CHANGE_CLASSES = {
  added: "bg-emerald-50 text-emerald-700 border-emerald-200",
  modified: "bg-amber-50 text-amber-800 border-amber-200",
  removed: "bg-red-50 text-red-700 border-red-200",
  unchanged: "bg-slate-50 text-slate-500 border-slate-200",
};

export const CHANGE_LABELS = {
  added: "Aggiunta",
  modified: "Modificata",
  removed: "Rimossa",
  unchanged: "Invariata",
};

export const EMPTY_SIGNATURE = {
  role: "datore_lavoro",
  signer_name: "",
  fiscal_code: "",
  data_certa_method: "firma_digitale",
  data_certa_reference: "",
  data_certa_date: new Date().toISOString().slice(0, 10),
  consultation_only: false,
  notes: "",
};
